import { Badge } from '@optools/components/ui/badge';
import { cn } from '@optools/components/ui/utils';
import { PipelineStatus } from '@optools/services/operator-gateway/types/generated/graphql';

const { ERROR, PENDING, PROVISIONED, RUNNING, SCHEDULED, WARNING } = PipelineStatus;

export interface PipelineStatusBadgeProps {
  status: PipelineStatus | null | undefined;
}

export function PipelineStatusBadge({ status }: PipelineStatusBadgeProps) {
  return (
    <Badge
      className={cn(
        'w-max bg-gray-700 text-xs font-normal text-white hover:bg-gray-700',
        (status === PENDING || status === SCHEDULED || status === PROVISIONED) &&
          'bg-sky-900 text-white hover:bg-sky-900',
        status === ERROR && 'bg-red-500 text-white hover:bg-red-500',
        status === RUNNING && 'bg-green-600 text-black hover:bg-green-600',
        status === WARNING && 'bg-amber-500 text-black hover:bg-amber-500',
      )}>
      {status ?? 'N/A'}
    </Badge>
  );
}
